export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11512.5e4c7be6.jpg";